var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box"},_vm._l((_vm.dataLst),function(item,index){return _c('a',{key:index,attrs:{"href":item.url,"target":"_blank"}},[_c('img',{attrs:{"src":item.img,"alt":item.title}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }